import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Collapsible,
  CollapsiblePanel,
  CollapsibleContent,
} from '@americanexpress/dls-react';
import Select from './Select';
import CurrencyInput from './CurrencyInput';
import RadioButton from './RadioButton';
import { parseHtml } from '../../utils/util';
import Button from './Button';
import Image from './Image';
import QrWrapper from './QrWrapper';

/**
 * component return DLS Accordion component
 * @param {*} props
 */
const DlsAccordion = ({
  cssProperties,
  nodeLabel,
  defaultOpenIds = [],
  nodeId,
  childElements,
  isEnableElements,
  memberInfo,
  formSubmissionPayload,
  setFormSubmissionPayload,
  handleOnChangeEvents,
}) => {
  // const [isCollapse, setIsCollapse] = useState(true);

  /**
   * handles accordion collapse and expand
   * functionlaity
   * @param {*} e
   */
  // const handleCollapse = (e) => {
  //   e.preventDefault();
  //   setIsCollapse(!isCollapse);
  // };

  /**
   * return accordion's child element
   * based on type passed
   * @param {*} elem
   */

  useEffect(() => {
    window.dispatchEvent(new Event('resize'));
  });

  const childSwitcher = (elem) => {
    switch (elem.fieldType) {
      case 'select':
        return (
          <Select
            {...elem}
            isEnableElements={isEnableElements}
            handleOnChangeEvents={handleOnChangeEvents}
          />
        );
      case 'currencyInput':
        return (<CurrencyInput {...elem} />);
      case 'radioButton':
        return (<RadioButton {...elem} />);
      case 'img':
        return (<Image {...elem} />);
      case 'button':
        return (<Button {...elem} />);

      case 'qrWrapper':
        return memberInfo && (
          <QrWrapper
            {...elem}
            memberInfo={memberInfo}
            handleOnChangeEvents={handleOnChangeEvents}
            setFormSubmissionPayload={setFormSubmissionPayload}
            formSubmissionPayload={formSubmissionPayload}
          />
        );
      case 'p':
        // /* eslint-disable max-len -- need */
        return elem.fieldIndicator
          && (
            <div
              className="row margin-2-t"
              style={{ maxWidth: '1000px', margin: '0 auto' }}
              key={elem.fieldId}
            >
              <p className={elem.cssProperties.style}>{parseHtml(elem.fieldValue)}</p>
            </div>
          );
      default:
        return null;
    }
  };

  return (
    <div className={cssProperties.style}>
      <Collapsible
        theme={{
          border: '0.0625rem solid #ecedee',
        }}
        defaultOpen={defaultOpenIds}
      >
        <CollapsiblePanel
          id={nodeId}
          theme={{
            color: '0.0625rem solid #001754',
            fontWeight: '600',
          }}
        >
          {nodeLabel}
        </CollapsiblePanel>
        <CollapsibleContent labelledBy={nodeId}>
          {
            childElements.map((elem) => elem.childElements.map(
              (childElem) => childSwitcher(childElem))
            )
          }
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

DlsAccordion.propTypes = {
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.string,
  fieldId: PropTypes.string,
  fieldType: PropTypes.string,
  defaultOpenIds: PropTypes.arrayOf(PropTypes.shape),
  nodeLabel: PropTypes.string,
  nodeId: PropTypes.string,
  childElements: PropTypes.objectOf(PropTypes.shape),
  isEnableElements: PropTypes.bool,
  memberInfo: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
  setFormSubmissionPayload: PropTypes.func,
  handleOnChangeEvents: PropTypes.func,
};

export default DlsAccordion;
